import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import './productDetails.scss';
import { CustomEvent, serviceCall } from "../../Utils/ServiceUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping, faStar, faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";

function ProductDetails() {
    const [productsLst, setProductsLst] = useState([]);
    const { id } = useParams();
    const [activeIndex, setActiveIndex] = useState(1);
    const [selectClr, setSelectClr] = useState("");
    const [addedtoCart, setAddedtoCart] = useState(false);
    let content = JSON.parse(localStorage.getItem("Content"));
    const navigate = useNavigate();

    useEffect(() => {
        productDetailsHandler();
    }, [])

    const productDetailsHandler = async () => {
        const resp = await serviceCall("GET", `/API/Product/GetProductById/${id}`);
        if (resp && !(resp.IsError === true)) {
            resp.Quantity = 1;
            resp.image = [resp.ImageUrl, resp.ImageUrl]
            setProductsLst([resp]);
            [resp].length > 0 && resp.colors && setSelectClr(resp.colors[0]);
        }
    }

    function incrementSlides(n) {
        setActiveIndex(prev => prev + n);
        if (activeIndex + n > productsLst[0].image.length) {
            setActiveIndex(1)
        }
        if (activeIndex + n < 1) {
            setActiveIndex(productsLst[0].image.length)
        }
    }

    async function addToCart() {
        let cartval = JSON.parse(localStorage.getItem("CartDetails"));
        let resp;
        let orderID = cartval.length > 0 ? cartval.filter(e => e.ProductId === productsLst[0].Id) : [];
        if (orderID.length > 0) {
            resp = await serviceCall("PUT", "/API/Cart/IncreaseQuantity", orderID[0].Id);
        } else {
            let reqBody = {
                "Id": productsLst[0].Id,
                "Size": 1
            }
            resp = await serviceCall("POST", `/API/Product/AddToCart`, reqBody);
        }
        if (resp && !(resp.IsError === false)) {
            console.log("added to cart");
            setAddedtoCart(true);
            const cartResp = await serviceCall("GET", "/API/Cart/GetCartProducts");
            if (cartResp && !(cartResp.IsError === true)) {
                window.localStorage.setItem("CartDetails", JSON.stringify(cartResp));
                window.dispatchEvent(CustomEvent("storage", { "detail": { "key": "Cart" } }));
            }
        }
    }

    return (
        <>
            <div className="prodctDetailCont">
            {productsLst.length > 0 ? <div className="containerProdt">
                <nav className="nav-links">
                    <Link to="/Home" style={{ textDecoration: "none" }}>
                        <a href={undefined}>Home</a>
                    </Link>
                    &nbsp;&gt;&nbsp;<a href={undefined}>{productsLst[0].ProductType}</a>
                </nav>
                <section className="product-details">
                    <div className="product-page-img">
                        <div className="big-images">
                            {productsLst[0].image.map((img, idx) => (
                                <div key={idx} className="mySlides" style={{ display: (idx + 1) === activeIndex ? "block" : "none" }}>
                                    <div className="numbertext">{idx + 1} / {productsLst[0].image.length}</div>
                                    <img src={img} alt="" />
                                </div>
                            ))}
                            <a href="#!" className="prev" onClick={() => incrementSlides(-1)}>&#10094;</a>
                            <a href="#!" className="next" onClick={() => incrementSlides(1)}>&#10095;</a>
                        </div>
                        <div className="slider-img" draggable="true">
                            {productsLst[0].image.map((img, idx) => (
                                <div key={idx} className={`slider-box ${idx + 1 === activeIndex ? "active" : ""}`} onClick={() => setActiveIndex(idx + 1)} >
                                    <img src={img} alt="" />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="product-page-details">
                        <strong>{productsLst[0].Name}</strong>
                        <p className="product-category">{productsLst[0].ProductType}</p>
                        <div className="review">
                            <span>{productsLst[0].stars}&nbsp;<FontAwesomeIcon icon={faStar} /></span>
                        </div>
                        <p className="product-price">${productsLst[0].Price}</p>
                        <p className="small-desc">{productsLst[0].Details}</p>
                        <div className="product-options">
                            <span>Colors:</span>
                            {productsLst[0].colors && productsLst[0].colors.map((clr, i) => {
                                return (<div key={clr}>
                                    <button className={clr === selectClr ? "active" : ""} style={{ "backgroundColor": `${clr}` }} onClick={() => setSelectClr(clr)}></button>
                                </div>)
                            })}
                        </div>
                        {/* <div className="product-page-offer">
                            <i className="fa-solid fa-tag"></i> 20% Discount
                        </div>
                        <div className="product-sold">
                            <strong>{productsLst[0].stock}&nbsp;<span>Available.</span></strong>
                        </div> */}
                        <div className="cart-btns">
                            {content ?
                                <><Button className="add-cart" onClick={() => addToCart()}><FontAwesomeIcon icon={faCartShopping} />&nbsp;Add to Cart</Button>
                                    <Button className="add-cart buy-now" onClick={() => (addToCart(), setTimeout(() => { navigate("/cartDetails") }, 1000))}>Buy Now</Button></>
                                :
                                <><Button className="add-cart" onClick={() => navigate("/Login")}><FontAwesomeIcon icon={faCartShopping} />&nbsp;Add to Cart</Button>
                                    <Button className="add-cart buy-now" onClick={() => navigate("/Login")}>Buy Now</Button>
                                </>}
                        </div>
                        {addedtoCart && <div style={{fontSize: "18px", marginTop: "15px"}}><FontAwesomeIcon style={{color: "green"}} icon={faCircleCheck} />&nbsp;Added to Cart</div>}
                    </div>
                </section>
            </div> : <div style={{ "height": "500px" }}></div>}
            </div>
        </>
    );
}

export default ProductDetails;